function handleSizeChartButtonClick(){
    const sizeChart = window.document.querySelector('.js_size-chart-guide');
    
    if (!sizeChart) return;

    const isVisible = sizeChart.classList.contains('hide');

    if(isVisible) {
        sizeChart.classList.remove('hide');
        window.document.body.style.overflowY = 'hidden';
    }
    else {
        sizeChart.classList.add('hide');
        window.document.body.style.overflowY = 'visible';
    }
}


window.addEventListener('DOMContentLoaded',function(){
    const sizeChartTriggers = window.document.querySelectorAll('.js_size-chart-trigger');
    const closeSizeChartButton = window.document.querySelector('.js_close-size-chart');

    if (sizeChartTriggers.length > 0){
        sizeChartTriggers.forEach(button => {
            button.addEventListener('click',handleSizeChartButtonClick);
        })
    }

    if(closeSizeChartButton){
        closeSizeChartButton.addEventListener('click',function(){
            handleSizeChartButtonClick()
        })
    }
})